<template>
  <div class="search">
    <div :class="!isShowNav?'on':''" class="search-wrapper">
      <div :class="!isShowNav?'cloak cloak-right border-left':'cloak cloak-right'" @click="searchOn(value)" class="is-hidden-touch iconfont">&#xe64c;</div>
      <div :class="!isShowNav?'cloak cloak-left border-right':'cloak cloak-left'" @click="searchOff()" class="is-hidden-touch iconfont">&#xe605;</div>
      <input type="text" placeholder="请输入您要搜索的关键词" :class="isShowNav?'opacity':''" ref="inputBtn" v-model="value" class="is-hidden-touch" @keyup.13="searchOn(value)">
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      isShowNav: true,
      value: ''
    }
  },
  methods: {
    // 搜索按钮
    searchOn (value) {
      if (value && !this.isShowNav) {
        // 发起请求 并跳转页面
        // alert("对"+value+"发起请求")
        let url = 'http://s.geekbang.org/search/c=0/k=' + value + '/t='
        window.open(url)
        this.value = ''
      } else {
        // 把导航栏取消
        this.isShowNav = !this.isShowNav
        this.$emit('searchDisplay')
      }
    },
    searchOff () {
      this.isShowNav = !this.isShowNav
      this.$emit('searchDisplay')
    }
  }
}
</script>
<style lang="sass" scoped>
@import "../../style/bulma/app.sass"
@import "../../style/icon/iconfont.css"

.search
  position: relative
  margin-right: 34px
  width: 28px
  height: 28px
  align-items: center
  div.search-wrapper
    background-color: #fff
    position: absolute
    width: 28px
    height: 28px
    overflow: hidden
    line-height: 28px
    border-radius: 14px
    padding: 0 0
    right: 0
    // top: -4px
    transition: width .5s
    .cloak
      position: absolute
      width: 28px
      height: 28px
      z-index: 1
      text-align: center
      color: #888
    .cloak-left
      background-color: #fff
      background-size: 40%
      left: 0
      cursor: pointer
    .cloak-right
      background-color: #fff
      right: 0
      z-index: 2
      font-size: 14px
      cursor: pointer
    input
      border-radius: 14px
      background-color: #fff
      border: none
      padding: 5px 38px
      // width: 30rem
      width: 100%
      height: 28px
      position: absolute
      left: 0
      outline: none
      font-size: 14px
      &::-webkit-input-placeholder  /* WebKit, Blink, Edge */
        font-size: 13px
        color: #888
      &:-moz-placeholder  /* Mozilla Firefox 4 to 18 */
        font-size: 13px
        color: #888

      &::-moz-placeholder  /* Mozilla Firefox 19+ */
        font-size: 13px
        color: #888
      &:-ms-input-placeholder /* Internet Explorer 10-11 */
        font-size: 13px
        color: #888

</style>
